<script lang="js">
import { RouterView } from 'vue-router';
import BaseNavbar from '@/components/base/BaseNavbar.vue';
import BaseFooter from '@/components/base/Footer.vue';

export default {
  name: 'App',
  computed: {
    hideHeader() {
      return this.$route.meta.hideHeader || false;
    },
    hideFooter() {
      return this.$route.meta.hideFooter || false;
    },
    isLoading() {
      return this.$store.getters.isLoading;
    }
  },
  components: {RouterView, BaseNavbar, BaseFooter}
}
</script>

<template>
  <div v-if="isLoading" class="loading-container">
    <div class="loading-spinner"></div>
    <p>Loading...</p>
  </div>
  <div v-else>
    <BaseNavbar v-if="!hideHeader" />
    <RouterView />
    <BaseFooter v-if="!hideFooter" />
  </div>
</template>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

img {
  pointer-events: none; /* Disables right-click and drag events */
  user-select: none; /* Disables text selection */
}

img::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
}

.loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f8f9fa;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e3e3e3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-container p {
  color: #666;
  font-size: 16px;
  margin: 0;
  left: 0;
  background: transparent;
}

img {
  -webkit-user-drag: none; /* Disable drag on webkit browsers */
  -webkit-touch-callout: none; /* Disable long-press to show context menu on iOS */
  -moz-user-select: none; /* Disable text selection on Firefox */
  -ms-user-select: none; /* Disable text selection on Internet Explorer */
}
</style>
